import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ICountryAlertModalData {
    country: string;
    title: string;
    alert: string;
}

@Component({
    selector: 'app-country-alert-modal',
    templateUrl: './country-alert-modal.component.html',
    styleUrls: ['./country-alert-modal.component.scss']
})
export class CountryAlertModalComponent {

    constructor(
        private readonly dialogRef: MatDialogRef<CountryAlertModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICountryAlertModalData
    ) { }

    public close(): void {
        this.dialogRef.close();
    }
}
